import React from 'react';


const LoadingOverlay = ({ loading }) => {
  if (!loading) return null;
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 9999,
      backgroundColor: 'rgba(52, 52, 52, 0.24)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}>
    </div>
  );
};

export default LoadingOverlay;